// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"21c0cf22","432":"3ee903e2","571":"948a99c3","720":"948a99c3","747":"5a6441c0","977":"948a99c3","986":"948a99c3"}[chunkId] + ".chunk.css";
};